(() => {
  function init(root) {
    if (root.dataset.ready) return;
    const articles = [...root.querySelectorAll('[data-wiki-article]')];
    const links = [...root.querySelectorAll('[data-wiki-link]')];
    const anchors = [...root.querySelectorAll('[data-wiki-anchor]')];
    const search = root.querySelector('[data-wiki-search]');
    let selected = root.dataset.default;
    const normalize = value => value.toLocaleLowerCase(root.lang || document.documentElement.lang || 'en').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}]/gu, '');
    function select(hash, scroll = false, focus = false) {
      const [handle, anchor] = hash.replace(/^#/, '').split('--');
      const article = articles.find(item => item.dataset.wikiArticle === handle) || articles.find(item => item.dataset.wikiArticle === root.dataset.default) || articles[0];
      if (!article) return;
      selected = article.dataset.wikiArticle;
      articles.forEach(item => { item.hidden = item !== article; });
      links.forEach(link => {
        if (link.dataset.wikiLink === selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      anchors.forEach(link => {
        link.href = '#' + selected + '--' + link.dataset.wikiAnchor;
        if (link.dataset.wikiAnchor === (anchor || 'intro')) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      const activeLink = links.find(link => link.dataset.wikiLink === selected);
      const directory = root.querySelector('.bw-entries');
      if (activeLink && directory.scrollWidth > directory.clientWidth) directory.scrollLeft = Math.max(0, activeLink.offsetLeft - directory.offsetLeft - 12);
      root.querySelector('[data-wiki-current]').textContent = article.querySelector('h1').textContent;
      const target = document.getElementById(selected + '--' + (anchor || 'intro')) || article;
      if (target.tagName === 'DETAILS') target.open = true;
      if (focus) article.querySelector('h1').focus({ preventScroll: true });
      if (scroll) target.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    if (new URLSearchParams(location.search).has('preview_key')) {
      document.querySelectorAll('a[href]').forEach(link => {
        if (new URL(link.href, location.href).pathname.endsWith('/pages/wiki')) link.href = location.pathname + location.search;
      });
    }
    root.dataset.ready = 'true';
    select(location.hash);
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-wiki-link], [data-wiki-anchor]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const hash = link.getAttribute('href');
      if (location.hash !== hash) history.pushState(null, '', hash);
      select(hash, true, link.hasAttribute('data-wiki-link'));
    });
    search.addEventListener('input', () => {
      const terms = search.value.trim().split(/\s+/).map(normalize).filter(Boolean);
      let count = 0;
      links.forEach(link => {
        const match = terms.every(term => normalize(link.dataset.search).includes(term));
        link.hidden = !match;
        if (match) count++;
      });
      root.querySelector('[data-wiki-empty]').hidden = count > 0;
      root.querySelector('[data-wiki-results]').textContent = count + ' ' + root.dataset.resultsLabel;
    });
    search.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        const first = links.find(link => !link.hidden);
        if (first) first.click();
      }
    });
    window.addEventListener('hashchange', () => select(location.hash, true));
    window.addEventListener('popstate', () => select(location.hash, true));
    document.addEventListener('shopify:block:select', event => {
      const article = event.target.closest('[data-wiki-article]');
      if (article && root.contains(article)) select('#' + article.dataset.wikiArticle, true);
    });
  }
  document.querySelectorAll('[data-wiki]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wiki]').forEach(init));
})();
